module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.length > 0),
      expression: "length>0"
    }],
    style: ({
      height: _vm.length + "px",
      top: "-" + _vm.length + "px"
    }),
    attrs: {
      "id": "refreshIndex"
    }
  }, [_c('div', {
    staticClass: "spinner",
    style: ({
      width: _vm.length * 0.8 + "px",
      height: _vm.length * 0.8 + "px"
    })
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2"
  })]), _vm._v(" "), _c('p', [_vm._v("松开我即可刷新页面商品信息哦！")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-c658aa56!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/refresh.vue
// module id = 55
// module chunks = 1